export default "__VITE_ASSET__33a9caa2__"